/* eslint-disable */
import VueStoreService from '@/services/VueStoreService';

const ReconProcessService = {
  processImport(batchId, store, defaultImporter) {
    const form = new FormData();
    const suffix = defaultImporter ? `?defaultImporter=${encodeURIComponent(defaultImporter)}` : '';
    return VueStoreService.postFile(`recon-imports/process/${batchId}${suffix}`, form, store);
  },

  processSale(batchId, store) {
    const form = new FormData();
    return VueStoreService.postFile(`recon-sales/process/${batchId}`, form, store);
  },

  runMatching(params, store) {
    const q = new URLSearchParams();
    if (params?.from) q.set('from', params.from);
    if (params?.to) q.set('to', params.to);
    if (params?.empresa && params.empresa !== 'Todas') q.set('empresa', params.empresa);
    if (params?.importador && params.importador !== 'Todas') q.set('importador', params.importador);

    const form = new FormData(); 
    const url = `recon-matching/run${q.toString() ? `?${q.toString()}` : ''}`;
    return VueStoreService.postFile(url, form, store);
  },

  listAllocations(params, store) {
    const q = new URLSearchParams();
    if (params?.from) q.set('from', params.from);
    if (params?.to) q.set('to', params.to);
    if (params?.empresa && params.empresa !== 'Todas') q.set('empresa', params.empresa);
    if (params?.importador && params.importador !== 'Todas') q.set('importador', params.importador);
    if (params?.code) q.set('code', params.code);
    if (params?.page) q.set('page', String(params.page));
    if (params?.size) q.set('size', String(params.size));

    return VueStoreService.get(`recon-matching${q.toString() ? `?${q.toString()}` : ''}`, store);
  },
};

export default ReconProcessService;
